import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo } from 'react';

import { capitalize } from 'lodash';
import { ChevronDownIcon } from 'lucide-react';
import { Button, Separator, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from 'twyne-new.ui'

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import appStore from 'stores/app';

import { usePostStore } from '../store';

import BuilderAction from './BuilderAction';
import Version from './Version';

const propTypes = {
  onView: PropTypes.func,
  sitePath: PropTypes.any,
  post: PropTypes.any,
  contentType: PropTypes.string,
  currentTitle: PropTypes.string,
  active: PropTypes.bool,
  onChangeActive: PropTypes.func,
};

function PostHeading({ onView, sitePath, contentType, active, onChangeActive }) {
  const { collection: { data, version: { versions, createVersion, saveVersion, deleteVersion } } } = usePostStore()
  const version = data?.versionId ? <>(version "<b>{data.description}</b>")</> : null
  const sitePathUrl = useMemo(() => {
    try {
      const editingVersion = versions?.find(v => v.id === data?.versionId)
      const url = new URL(sitePath)
      if (editingVersion) {
        url.searchParams.set('__version', editingVersion.description)
      }
      return url.toString()
    } catch (error) {
      return sitePath
    }
  }, [versions, data?.versionId, sitePath])

  useEffect(() => {
    appStore.setLayout('heading', true)
    return () => {
      appStore.setLayout('heading', false)
    }
  }, [versions, data?.versionId, sitePath])

  const handleCreateNewVersion = useCallback(async ({ description }) => await createVersion({ description }), [createVersion])
  const handleDeleteVersion = useCallback(async cmsPostVersionId => await deleteVersion(cmsPostVersionId), [deleteVersion])
  const handleActiveVersion = useCallback(async (version, active) => {
    const { id: versionId, cms_post_id: id } = version
    await saveVersion({ ...version, active, id, versionId })
  }, [saveVersion])

  return <>
    <HeaderContainerForm
      data={{ ...data, title: data?.title, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      title={capitalize(contentType)}
      onCancel={() => history.goBack()}
      className='relative'
    >
      <ActiveForm active={active} onChangeActive={onChangeActive} />
      {data && <>
        <Separator orientation='vertical' className='py-4' />
        <DropdownMenu optionsLabel='Options'>
          <DropdownMenuTrigger className='flex items-center gap-1'>
            <Button size='lg' variant='outline'>
              Quick Actions
              <ChevronDownIcon size={16} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align='start' forceMount>
            <BuilderAction row={data} suffix="builder" />
            <Version
              data={versions}
              number={version}
              onView={onView}
              onActive={handleActiveVersion}
              onDelete={handleDeleteVersion}
              onCreate={handleCreateNewVersion}
            />
            <DropdownMenuItem onClick={() => window.open(sitePathUrl, '_blank')}>
              Go to site
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </>}
    </HeaderContainerForm>
  </>
}

PostHeading.propTypes = propTypes

export default PostHeading;
